
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import CodeMirrorWrapper from "@/components/Reusable/CustomInputs/3rdPartyWrappers/CodeMirrorWrapper.vue";
import { Tag } from "@/types/tags";
import Icon from "@/components/UI/Icon.vue";
import { CodeInputLanguage } from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import { getPlatform } from "@/util/get-platform";

@Component({
  components: { Icon, CodeMirrorWrapper }
})
export default class CodeInputDialog extends Vue {
  @Prop()
  value: unknown;

  @Prop()
  autofillOnEmpty!: string | null;

  @Prop({ default: "" })
  placeholder!: string;

  @Prop()
  open!: boolean;

  @Prop()
  language!: CodeInputLanguage;

  @Prop({
    default() {
      return [];
    }
  })
  tags!: Tag[];

  @Prop({
    default() {
      return [];
    }
  })
  twigVariables!: string[];

  @Prop({ default: null })
  focusAtPosition!: number | null;

  @Prop({ default: false })
  formatting!: boolean;

  @Prop({ default: false })
  formattable!: boolean;

  onFormat() {
    this.$emit("format");
  }

  beforeCreate() {
    // @ts-ignore
    this.$options.components.CodeInput =
      require("@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue").default;
  }

  get title() {
    return this.language.replace("x-", "");
  }

  get isMac() {
    const platform = getPlatform().toLowerCase();
    return /mac/.test(platform);
  }

  get formatShortcut() {
    return this.isMac ? "⌘+⌥+L" : "Ctrl+Alt+L";
  }

  edit(newVal: string | null) {
    if (!newVal) {
      this.$emit("input", null);
      return;
    }

    this.$emit("input", newVal);
  }

  closeDialog() {
    this.$emit("close");
  }
}
